export const sl = {
    LEFT: 'Levo: Premaknite se na prejšnji dan.',
    RIGHT: 'Desno: Premakniti na naslednji dan.',
    DOWN: 'Navzdol: Premakniti v naslednjo vrstico.',
    UP: 'Up: Premaknite se na prejšnji vrstici.',
    PGUP: 'PgUp: Premaknite se na prejšnji mesec.',
    PGDOWN: 'PgDown: Premaknite se na naslednji mesec.',
    HOME: 'Domača stran: Premaknite se na prejšnji leto.',
    END: 'Konec: Premik v naslednje leto.',
    ESC: 'Esc/Danes/Zapiranje: zaprite koledar.',
    TITLE: 'Keyboard Navodila'
};
